import { Http } from '@/model/Http.js'

export default class home extends Http {
  //首页-本月新增、15天订单数
  getStatisticsData(data){
    const url = 'api/open/platform-stat/query'
    return this.postAjaxByKfc(url, {
      ...data
       // ...param
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/home.js